import React from 'react';
/* Komponent ikony */
export var Icon = function (props) { return (React.createElement("img", { className: props.className, src: props.path, alt: props.path, onClick: props.onClick, style: props.style, "data-cy": props.dataCy })); };
